import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { type PresentacionEditDialogProps } from '../types/especie';
import { usePresentacionForm } from '../hooks/usePresentacionForm';

export const EditPresentacion: React.FC<PresentacionEditDialogProps> = ({
  open,
  presentacionId,
  idEspecie,
  onClose,
  onSave,
  title = 'Editar Presentación',
}) => {
  const {
    formData,
    errors,
    loading,
    isValid,
    handleChange,
    handleSwitchChange,
    handleSubmit,
    resetForm,
  } = usePresentacionForm(presentacionId, idEspecie, onSave);

  React.useEffect(() => {
    if (open && !presentacionId) {
      resetForm();
    }
  }, [open, presentacionId, resetForm]);

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        component: 'form',
        onSubmit: handleFormSubmit,
      }}
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="Descripción"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            error={!!errors.descripcion}
            helperText={errors.descripcion}
            required
            fullWidth
            autoFocus
          />

          <FormControlLabel
            control={
              <Switch
                checked={formData.esFresco}
                onChange={handleSwitchChange}
                name="esFresco"
              />
            }
            label="Es Fresco"
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          type="submit"
          variant="contained"
          disabled={!isValid || loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Guardando...' : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};